import React from 'react';
import { PromotionManager } from '../components/PromotionManager';

export const Promotions: React.FC = () => <PromotionManager />;
